import { ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";

import tenantConfig from "../../../tenant.config";
import { PrimeLink } from "../../prime/link";
import { AuthOtpComponent } from "./Otp";
import { OtpFormSchemaType } from "./OtpFormSchema";

interface AuthVerifyOtpComponentProps {
  email: string;
  onSubmit: (data: OtpFormSchemaType) => Promise<void>;
  useFormProps: UseFormReturn<OtpFormSchemaType>;
  isFetching: boolean;
  ids?: {
    box?: string;
    email?: string;
    form?: string;
  };
}

const renderFooter = (): ReactNode => {
  switch (tenantConfig.entity_short_name.toLowerCase()) {
    case "alta":
      return (
        <>
          If you have any issues with signing in, please refer to our{" "}
          <PrimeLink href={tenantConfig.entity_otp_help_url} nextLink newTab>
            Helpdesk
          </PrimeLink>{" "}
          or contact us at{" "}
          <PrimeLink href={"mailto:" + tenantConfig.email.generic}>
            {tenantConfig.email.generic}
          </PrimeLink>
          .
        </>
      );
    default:
      return (
        <>
          If you have any issues with signing in, contact us at{" "}
          <PrimeLink href={"mailto:" + tenantConfig.email.generic}>
            {tenantConfig.email.generic}
          </PrimeLink>
          .
        </>
      );
  }
};

export const AuthVerifyOtpComponent = (props: AuthVerifyOtpComponentProps) => {
  const { email, onSubmit, useFormProps, isFetching, ids } = props;

  return (
    <>
      <h1 className="font-light tracking-wide">Two-factor authentication</h1>
      <div id={ids?.box}>
        <h2>Check your email</h2>
        <p>
          <span>Please enter OTP sent to:</span>
          <br />
          <span id={ids?.email} className="font-bold text-black">
            {email}
          </span>
        </p>
        <AuthOtpComponent
          useFormProps={useFormProps}
          onSubmit={onSubmit}
          isFetching={isFetching}
          componentId={ids?.form}
        />
        <p className="pt-2 text-xs leading-normal">
          You will receive an email if an account exists.
          <span className="block mt-1">{renderFooter()}</span>
        </p>
      </div>
    </>
  );
};
